import { render, staticRenderFns } from "./Mainlinks.vue?vue&type=template&id=5d7fc334&"
import script from "./Mainlinks.vue?vue&type=script&lang=js&"
export * from "./Mainlinks.vue?vue&type=script&lang=js&"
import style0 from "./Mainlinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Mainlinks.vue"
export default component.exports